// @flow
/* eslint-disable ta-code-conventions/has-matching-storydoc */
import * as React from 'react';
import { localize } from '@ta/common.i18n';
import ListItem from './ListItem';
import type { ListSize } from './ListItem';

const SMS_CHAR_LIMIT: number = 140;

const shareViaSms = (url: string, firstSentence: string) => {
  let body: string = `${firstSentence} ${url}`;
  if (body.length > SMS_CHAR_LIMIT) {
    body = url;
  }
  // eslint-disable-next-line no-restricted-globals
  window.location.href = `sms:?&body=${encodeURIComponent(body)}`; // The URL schema needs to be compatible with both Android and iOS
};

type ShareViaSmsProps = {
  url: string,
  itemType: string,
  size: ListSize,
};

const ShareViaSms = ({ url, itemType, size }: ShareViaSmsProps) => {
  let firstSentence;
  if (itemType === 'LinkPost') {
    firstSentence = localize('share_sms_link');
  } else if (itemType === 'ReadTrip') {
    firstSentence = localize('trips_share_email_subject');
  } else if (itemType === 'WriteTrip') {
    firstSentence = localize('trips_collaborate_invite_email_subject');
  } else {
    // NotMyTrip
    firstSentence = localize('link_share_sms_checkthisout');
  }

  return (
    <ListItem
      iconName="text-message-fill"
      localizedText={localize('link_share_option_sms')}
      size={size}
      onClickFunction={() => shareViaSms(url, firstSentence)}
    />
  );
};

export default ShareViaSms;
